import {http_client} from "@/plugins/http_client";
const urlNomina = process.env.VUE_APP_PLANILLA_API_URL

const getInstruccionesEvaluacion = async (id_solicitud_evaluacion) => await http_client(`${urlNomina}/api/v1/contratacion-evaluacion/instrucciones/${id_solicitud_evaluacion}`, {}, 'get');

const startExam = async (id_solicitud_evaluacion) => await http_client(`${urlNomina}/api/v1/contratacion-evaluacion/iniciar/${id_solicitud_evaluacion}`, {}, 'post' );
const getObtenerPregunta = async (uuid_evaluacion_respuesta, numero) => await http_client(`${urlNomina}/api/v1/contratacion-evaluacion/${uuid_evaluacion_respuesta}/pregunta/${numero}`, {}, 'get');
const guardarRespuesta = async (uuid_evaluacion_respuesta, id_pregunta, body) => await http_client(`${urlNomina}/api/v1/contratacion-evaluacion/${uuid_evaluacion_respuesta}/pregunta/${id_pregunta}`, body,  'patch');
const getResumen = async (uuid_evaluacion_respuesta) => await http_client(`${urlNomina}/api/v1/contratacion-evaluacion/${uuid_evaluacion_respuesta}/resumen`, {}, 'get');
const endExam = async (uuid_evaluacion_respuesta) => await http_client(`${urlNomina}/api/v1/contratacion-evaluacion/${uuid_evaluacion_respuesta}/finalizar`, {}, 'post')

const getProcesoContratacion = async (id_oferta) => await http_client(`${urlNomina}/api/v1/contratacion-evaluacion/proceso/${id_oferta}`, {}, 'get');

export default{
    getInstruccionesEvaluacion,
    startExam,
    getObtenerPregunta,
    guardarRespuesta,
    getResumen,
    endExam,
    getProcesoContratacion
}